import {
  Button,
  ButtonProps,
  Card,
  CardBody,
  CardFooter,
  Container,
  Heading,
  Text,
} from '@chakra-ui/react'
import { ListRecordingsPage } from '@features/recordings/components/ListRecordingsPage'
import { createFileRoute, Link, useParams } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { paginationRequestSchema } from '@customTypes/cloudmix/api'
import { withListHydration } from '@lib/listState/withListHydration'
import { Route as listSessionsRoute } from '@routes/_auth/o/$orgId/projects/$projectId/s'
import { withSentryErrorReporting } from '@components/Fallback'

const ListRecordingsFallback = () => {
  const { orgId, projectId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/',
  })

  return (
    <Card variant={'outline'}>
      <CardBody>
        <Heading size="md">
          There seems to be a problem loading this session.
        </Heading>
        <Text py="2">
          Try loading the page again or select another session from the list
        </Text>
      </CardBody>
      <CardFooter>
        <Link
          to={listSessionsRoute.to}
          params={{ orgId, projectId }}
          search={() => ({})}
        >
          <Button>Back to sessions list</Button>
        </Link>
      </CardFooter>
    </Card>
  )
}

const BackButton = (props: ButtonProps) => {
  const { orgId, projectId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/',
  })

  return (
    <Link
      to={listSessionsRoute.to}
      params={{ orgId, projectId }}
      search={() => ({})}
    >
      <Button {...props} size="xs">
        Back to sessions
      </Button>
    </Link>
  )
}

const ListRecordingsRoute = () => {
  const { workflowSessionId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/',
  })

  return (
    <Container maxW={'75rem'}>
      <BackButton />
      <ListRecordingsPage workflowSessionId={workflowSessionId} />
    </Container>
  )
}

const routerSchema = paginationRequestSchema.partial().catch({})
export const Route = createFileRoute(
  '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/'
)({
  component: ListRecordingsRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: {},
    getTitle: () => 'Recordings',
  }),
  errorComponent: withSentryErrorReporting(ListRecordingsFallback),
})
